/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


(function(){
  let myContainer = document.querySelector('#shopify-section-1494463442222');
  if(typeof(myContainer) != 'undefined' && myContainer != null){
	if(myContainer.classList.contains('js-section__home-collection')) {     
        document.querySelectorAll('a[href$="/products/premade-weighted-blankets"]').forEach(anchor => {
        	anchor.setAttribute('href', 'https://weightedblanketsplus.com/collections/premade-weighted-blankets')
        })
        document.querySelectorAll('a[href$="/products/custom-weighted-blankets"]').forEach(anchor => {
        	anchor.setAttribute('href', 'https://weightedblanketsplus.com/collections/custom-weighted-blankets')
        })
        document.querySelectorAll('a[href$="/products/ready-to-ship-40-off"]').forEach(anchor => {
        	anchor.setAttribute('href', 'https://weightedblanketsplus.com/collections/ready-to-ship-40-off')
        })
        document.querySelectorAll('a[href$="/collections/frontpage/products/weighted-lap-pads"]').forEach(anchor => {
        	anchor.setAttribute('href', 'https://weightedblanketsplus.com/collections/weighted-lap-pads')
        })
        document.querySelectorAll('a[href$="/products/weighted-lap-pads"]').forEach(anchor => {
        	anchor.setAttribute('href', 'https://weightedblanketsplus.com/collections/weighted-lap-pads')
        })
    }
  }
 
})();


(function(){
  let myContainer = document.querySelector('#shopify-section-collection-template');
  if(typeof(myContainer) != 'undefined' && myContainer != null){
	if(myContainer.classList.contains('js-section__collection')) {     
        document.querySelectorAll('a[href$="/products/small"]').forEach(anchor => {
        	anchor.setAttribute('href', 'https://weightedblanketsplus.com/collections/small')
        })
        document.querySelectorAll('a[href$="/products/medium"]').forEach(anchor => {
        	anchor.setAttribute('href', 'https://weightedblanketsplus.com/collections/medium')
        })
        document.querySelectorAll('a[href$="/products/large"]').forEach(anchor => {
        	anchor.setAttribute('href', 'https://weightedblanketsplus.com/collections/large')
        })
    }
  }
 
})();



// Custom code for Custom Product Builder
(function(){
  function BackBTN_Add() {
    var button = document.createElement("button");
    button.setAttribute("class", "back-button");
    var text = document.createTextNode("< Back");
    button.appendChild(text);
    var element = document.querySelector(".cpb-product-actions-container");
    element.prepend(button);
  }

  function BackBTN_Func() {
    jQuery('.back-button').on('click', function() {
      var active = document.querySelector('.cpb-active');
      var activeID = active.getAttribute('id');
      var activeID_Index = activeID.length === 13 ?  activeID[11] + "" + activeID[12] : activeID[11];
      document.querySelector(`#react-tabs-${parseInt(activeID_Index) - 2}`).click();
    });
  }

  function oldPrice(amount) {
    var target = document.querySelector('[data-intro="Product Price"]');
    var config = { characterData: true, attributes: false, childList: true, subtree: true };

    function mutate(mutations) {
      mutations.forEach(function(mutation) {
        if(mutation.type === "characterData") {
          if(document.querySelectorAll(".old-price").length) {
            document.querySelector(".old-price").remove()
          }
          var item = target.children[0].children[0];
          var text = item.textContent;
          var price = text.substr(1,text.length)
          if(price != 0) {
            oldPrice = Number.parseFloat( price * amount).toFixed(2);
            var span = document.createElement("span");
            span.setAttribute("style", "text-decoration: line-through; color: crimson; margin-right: 8px;");
            span.setAttribute("class", "old-price");
            var text = document.createTextNode("$" + oldPrice);
            span.appendChild(text);
            target.children[0].children[0].prepend(span);
          }
        } else if (mutation.type === "childList" && mutation.removedNodes.length > 0) {
          var item = target.children[0].children[0];
          var text = item.textContent;
          var price = text.substr(1,text.length)
          if(price != 0) {
            oldPrice = Number.parseFloat( price * amount).toFixed(2);
            var span = document.createElement("span");
            span.setAttribute("style", "text-decoration: line-through; color: crimson; margin-right: 8px;");
            span.setAttribute("class", "old-price");
            var text = document.createTextNode("$" + oldPrice);
            span.appendChild(text);
            target.children[0].children[0].prepend(span);
          }
      	};
      });
    }
    var observer = new MutationObserver( mutate );
    observer.observe(target, config)
  }

  function scrollUp() {
    if(jQuery('.pdp-title').length) {
      jQuery('html, body').animate({
        scrollTop: jQuery('.pdp-title').offset().top - 200
      }, 300)
    }
  }

  function customJS(observer, changeButton) {
	changeButton();
    
    jQuery('.col-tabs').on('classChange', function() {
        window.requestAnimationFrame(changeButton);
    })

    var element = document.querySelector('.col-tabs');

    observer.observe(element, {
      attributes: true, 
      attributeFilter: ['class'],
      childList: false, 
      characterData: false
    })
  }


  function addReference(referenceString, descriptionString) {
    var relatedID = document.querySelector('#shopify-section-product-related');

    var referenceObject = document.createElement('div');
    referenceObject.setAttribute("class", "shopify-section js-section__size-reference")
    referenceObject.setAttribute("id", "shopify-section-size-reference")
    referenceObject.innerHTML = referenceString;

    var descriptionObject = document.createElement('div');
    descriptionObject.setAttribute("class", "shopify-section js-section__material-description")
    descriptionObject.setAttribute("id", "shopify-section-material-description")
    descriptionObject.innerHTML = descriptionString;

    if (relatedID) {
      relatedID.parentNode.insertBefore(referenceObject, relatedID);
      relatedID.parentNode.insertBefore(descriptionObject, relatedID);
    }

  }

  function scrollHrefs(href) {
    document.addEventListener( "click", scrollMe );
    function scrollMe(event){
      var element = event.target;
      if(element.getAttribute('href') === href) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: jQuery(element.getAttribute('href')).offset().top - 150
        }, 300)
      }
    }
  }

  function cpbLoaded() {
   
    if (jQuery('#react-tabs-8').length > 0) {
      BackBTN_Add();
      BackBTN_Func();

      // ---------------------------------------------------

      // start of product IF
      if (window.location.pathname.includes('/products/weighted-lap-pads')) {
        var referenceString = ''
        var descriptionString = '<section class="section section--material-description"><div class="container"><div class="material-description js-material-description"><div class="o-layout o-layout--center"><div class="o-layout__item u-1/1 u-1/1@phab u-1/1@tab"><h3 id="flannel">Flannel</h3><p>Flannel is a breathable material that provides luxurious softness and will let your body breathe without perspiring too much. Flannel doesn\'t need to be ironed, can be washed and dried at low to moderate temperatures and requires low maintenance. Due to its warm nature, flannel products are best suited to colder months. <span class="back-to-product">Go back to product</span></p><h3 id="fleece">Fleece</h3><p>Fleece is a warm, cozy material, a wonderful alternative for those who love wool but are sensitive to the fabric. Unlike wool, fleece is made from synthetic materials and is lightweight. This lush fabric is also soft, durable, and tactile to the touch, making it a popular choice for sensory children and adults who are under sensitive to touch and look for extra sensory input. Being a good heat retainer, fleece is perfect for fall and winter. <span class="back-to-product">Go back to product</span></p><h3 id="cotton">Cotton</h3><p>Cotton is a natural biodegradable fiber and a popular choice for weighted products. More breathable than synthetic fabrics, it helps to release excess body heat into the air keeping you cool at night. Cotton is also smooth to the touch making it a good option for those who want to avoid more tactile fabrics such as fleece. Among its other features, cotton is easy to wash, doesn’t require dry cleaning. <span class="back-to-product">Go back to product</span></p><h3 id="denim">Denim</h3><p>Denim is a hardwearing, durable material that\'s built to last. It is a naturally heavy fabric which makes it a perfect choice for weighted blankets and lap pads. Products are made with denim on both sides and are also weighted with glass beads. This comfortable material is both washer and dryer safe. <span class="back-to-product">Go back to product</span></p></div></div></div></div></section>'

        addReference(referenceString, descriptionString);

        function changeButton() {
          switch(document.querySelector(".cpb-active").getAttribute('id')) {
               case "react-tabs-0":
                jQuery(".cpb-next-tab-button span").text("Select Weight & Size");
              jQuery(".back-button")
                break;
            case "react-tabs-2":
                jQuery(".cpb-next-tab-button span").text("Customize Side A");
                break;
            case "react-tabs-4":
                jQuery(".cpb-next-tab-button span").text("Customize Side B");
                break;
            case "react-tabs-6":
                jQuery(".cpb-next-tab-button span").text("Review Summary");
                break;
              default:
                  break;
                }

          scrollUp()
        }

		scrollHrefs('#flannel');      

      } // end of IF
      
      
       // start of product IF
      if (window.location.pathname.includes('/products/weighted-neck-wraps')) {
        var referenceString = ''
        var descriptionString = '<section class="section section--material-description"><div class="container"><div class="material-description js-material-description"><div class="o-layout o-layout--center"><div class="o-layout__item u-1/1 u-1/1@phab u-1/1@tab"><h3 id="flannel">Flannel</h3><p>Flannel is a breathable material that provides luxurious softness and will let your body breathe without perspiring too much. Flannel doesn\'t need to be ironed, can be washed and dried at low to moderate temperatures and requires low maintenance. Due to its warm nature, flannel products are best suited to colder months. <span class="back-to-product">Go back to product</span></p><h3 id="fleece">Fleece</h3><p>Fleece is a warm, cozy material, a wonderful alternative for those who love wool but are sensitive to the fabric. Unlike wool, fleece is made from synthetic materials and is lightweight. This lush fabric is also soft, durable, and tactile to the touch, making it a popular choice for sensory children and adults who are under sensitive to touch and look for extra sensory input. Being a good heat retainer, fleece is perfect for fall and winter. <span class="back-to-product">Go back to product</span></p><h3 id="cotton">Cotton</h3><p>Cotton is a natural biodegradable fiber and a popular choice for weighted products. More breathable than synthetic fabrics, it helps to release excess body heat into the air keeping you cool at night. Cotton is also smooth to the touch making it a good option for those who want to avoid more tactile fabrics such as fleece. Among its other features, cotton is easy to wash, doesn’t require dry cleaning. <span class="back-to-product">Go back to product</span></p><h3 id="denim">Denim</h3><p>Denim is a hardwearing, durable material that\'s built to last. It is a naturally heavy fabric which makes it a perfect choice for weighted blankets and lap pads. Products are made with denim on both sides and are also weighted with glass beads. This comfortable material is both washer and dryer safe. <span class="back-to-product">Go back to product</span></p></div></div></div></div></section>'

        addReference(referenceString, descriptionString);

        function changeButton() {
          switch(document.querySelector(".cpb-active").getAttribute('id')) {
              case "react-tabs-0":
           		 jQuery(".cpb-next-tab-button span").text("Select Weight & Size");
              	jQuery(".back-button")
           	  	 break;
              case "react-tabs-2":
                  jQuery(".cpb-next-tab-button span").text("Customize Side A");
                  break;
              case "react-tabs-4":
                  jQuery(".cpb-next-tab-button span").text("Customize Side B");
                  break;
              case "react-tabs-6":
                  jQuery(".cpb-next-tab-button span").text("Review Summary");
                  break;
              default:
                  break;
                }

          scrollUp()
        }

		scrollHrefs('#flannel');      

      } // end of IF
      
      
        // start of product IF
      if (window.location.pathname.includes('/products/weighted-stuffed-animals')) {
        var referenceString = ''
        var descriptionString = ''

        addReference(referenceString, descriptionString);

        function changeButton() {
          switch(document.querySelector(".cpb-active").getAttribute('id')) {
               case "react-tabs-0":
                    jQuery(".cpb-next-tab-button span").text("Select Animal");
              		jQuery(".back-button")
                    break;
                case "react-tabs-2":
                    jQuery(".cpb-next-tab-button span").text("Review Summary");
                    break;
              default:
                  break;
                }

          scrollUp()
        }

		scrollHrefs('#flannel');      

      } // end of IF
      
      
      // start of product IF
      if (window.location.pathname.includes('/products/medical-weighted-blankets')) {
        var referenceString = ''
        var descriptionString = ''

        addReference(referenceString, descriptionString);

        function changeButton() {
          switch(document.querySelector(".cpb-active").getAttribute('id')) {
                 case "react-tabs-0":
                    jQuery(".cpb-next-tab-button span").text("Select Weight & Size");
              		jQuery(".back-button")
                    break;
                case "react-tabs-2":
                    jQuery(".cpb-next-tab-button span").text("Select Material");
                    break;
                case "react-tabs-4":
                    jQuery(".cpb-next-tab-button span").text("Review Summary");
                    break;
              default:
                  break;
                }

          scrollUp()
        }

		scrollHrefs('#flannel');      

      } // end of IF
      
      
      // start of product IF
      if (window.location.pathname.includes('/products/standard-weighted-blankets')) {
        var referenceString = '<section class="section section--size-reference"><div class="container"><div class="size-reference js-size-reference"><div class="o-layout o-layout--center"><div class="o-layout__item u-1/1 u-1/1@phab u-1/1@tab"><img src="//cdn.shopify.com/s/files/1/0052/5595/4535/files/weight_size_chart.jpg" alt="Weight & Size Reference"/></div></div></div></div></section>'
        var descriptionString = '<section class="section section--material-description"><div class="container"><div class="material-description js-material-description"><div class="o-layout o-layout--center"><div class="o-layout__item u-1/1 u-1/1@phab u-1/1@tab"><h3 id="flannel">Flannel</h3><p>Flannel is a breathable material that provides luxurious softness and will let your body breathe without perspiring too much. Flannel doesn\'t need to be ironed, can be washed and dried at low to moderate temperatures and requires low maintenance. Due to its warm nature, flannel products are best suited to colder months. <span class="back-to-product">Go back to product</span></p><h3 id="fleece">Fleece</h3><p>Fleece is a warm, cozy material, a wonderful alternative for those who love wool but are sensitive to the fabric. Unlike wool, fleece is made from synthetic materials and is lightweight. This lush fabric is also soft, durable, and tactile to the touch, making it a popular choice for sensory children and adults who are under sensitive to touch and look for extra sensory input. Being a good heat retainer, fleece is perfect for fall and winter. <span class="back-to-product">Go back to product</span></p><h3 id="cotton">Cotton</h3><p>Cotton is a natural biodegradable fiber and a popular choice for weighted products. More breathable than synthetic fabrics, it helps to release excess body heat into the air keeping you cool at night. Cotton is also smooth to the touch making it a good option for those who want to avoid more tactile fabrics such as fleece. Among its other features, cotton is easy to wash, doesn’t require dry cleaning. <span class="back-to-product">Go back to product</span></p><h3 id="denim">Denim</h3><p>Denim is a hardwearing, durable material that\'s built to last. It is a naturally heavy fabric which makes it a perfect choice for weighted blankets and lap pads. Products are made with denim on both sides and are also weighted with glass beads. This comfortable material is both washer and dryer safe. <span class="back-to-product">Go back to product</span></p></div></div></div></div></section>'

        addReference(referenceString, descriptionString);

        function changeButton() {
          switch(document.querySelector(".cpb-active").getAttribute('id')) {
                  case "react-tabs-0":
                      jQuery(".cpb-next-tab-button span").text("Select Weight & Size");
                      jQuery(".back-button")
                      break;
                  case "react-tabs-2":
                      jQuery(".cpb-next-tab-button span").text("Customize Side A");
                      break;
                  case "react-tabs-4":
                      jQuery(".cpb-next-tab-button span").text("Customize Side B");
                      break;
                  case "react-tabs-6":
                      jQuery(".cpb-next-tab-button span").text("Review Summary");
                      break;
              default:
                  break;
                }

          scrollUp()
        }

		scrollHrefs('#flannel');  
/**        oldPrice(1.6667); **/

      } // end of IF
      
            // start of product IF
      if (window.location.pathname.includes('/products/organic-weighted-blankets')) {
        var referenceString = '<section class="section section--size-reference"><div class="container"><div class="size-reference js-size-reference"><div class="o-layout o-layout--center"><div class="o-layout__item u-1/1 u-1/1@phab u-1/1@tab"><img src="//cdn.shopify.com/s/files/1/0052/5595/4535/files/weight_size_chart.jpg" alt="Weight & Size Reference"/></div></div></div></div></section>'
        var descriptionString = ''

        addReference(referenceString, descriptionString);

        function changeButton() {
          switch(document.querySelector(".cpb-active").getAttribute('id')) {
                  case "react-tabs-0":
                      jQuery(".cpb-next-tab-button span").text("Select Weight & Size");
                      jQuery(".back-button")
                      break;
                  case "react-tabs-2":
                      jQuery(".cpb-next-tab-button span").text("Customize Side A");
                      break;
                  case "react-tabs-4":
                      jQuery(".cpb-next-tab-button span").text("Customize Side B");
                      break;
                  case "react-tabs-6":
                      jQuery(".cpb-next-tab-button span").text("Review Summary");
                      break;
              default:
                  break;
                }

          scrollUp()
        }

		scrollHrefs('#flannel');  
/**        oldPrice(1.6667); **/

      } // end of IF
      
      
      
      // ---------------------------------------------------


      var observer = new MutationObserver((event) => {
        changeButton();
      })

      customJS(observer, changeButton);

      document.querySelectorAll('.back-to-product').forEach(el => el.addEventListener('click', scrollUp))
    } else {
      window.requestAnimationFrame(cpbLoaded);
    }
  }


  document.addEventListener("load", cpbLoaded());


})();